var _rect, _polygon, _polygon2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCzechRepublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "5.13 0 24 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.13,
    width: 24,
    height: 17,
    fill: "#11457e",
    strokeWidth: 0.048223
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(.046784 0 0 .049708 5.13 0)",
    points: "513 342 0 342 215 171 513 171",
    fill: "#d7141a"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(.046784 0 0 .049708 5.13 0)",
    points: "513 171 215.18 171 0 0 513 0",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCzechRepublic);
export default __webpack_public_path__ + "static/media/czech-republic.64db8dcf6669674825d62dbc9a8e1346.svg";
export { ForwardRef as ReactComponent };